import { Injectable } from '@angular/core';
import { AbstractListViewService, ListViewData } from '@y42/core/list-view';
import { DatasourceListViewData, DatasourceUIModel } from '@y42/datasource';
import { IntegrationQuery } from '@y42/integration';
import { SqlModelingQuery } from '@y42/sql-model';
import { UiModelingQuery } from '@y42/ui-model';
import { combineLatest, map, Observable } from 'rxjs';
import {
  OrchestrationSupportedEntityTypeEnum,
  OrchestrationTablesPickerPopupService,
} from '../orchestration-tables-picker-popup.service';

type OrchestrationStructureListViewData = ListViewData<DatasourceUIModel>;

@Injectable()
export class OrchestrationDatasourceSelectorService extends AbstractListViewService<OrchestrationStructureListViewData> {
  constructor(
    private readonly orchestrationTablesPickerPopupService: OrchestrationTablesPickerPopupService,
    private readonly integrationQuery: IntegrationQuery,
    private readonly uiModelingQuery: UiModelingQuery,
    private readonly sqlModelingQuery: SqlModelingQuery,
  ) {
    super();
  }

  readonly data$: Observable<DatasourceListViewData[]> = combineLatest([
    this.integrationQuery.listItems$.pipe(map((items) => items.filter((item) => item.hasReadPermission))),
    this.uiModelingQuery.listItems$.pipe(map((items) => items.filter((item) => item.hasReadPermission))),
    this.sqlModelingQuery.listItems$.pipe(map((items) => items.filter((item) => item.hasReadPermission))),
    this.orchestrationTablesPickerPopupService.activeAssetType$,
  ]).pipe(
    map(([integrationList, uiModelingList, sqlModelingList, activeTab]) => {
      switch (activeTab) {
        case OrchestrationSupportedEntityTypeEnum.Integrations:
          return integrationList;
        case OrchestrationSupportedEntityTypeEnum.Models:
          return [...uiModelingList, ...sqlModelingList];
        default:
          return [];
      }
    }),
    map((listItems) => listItems.filter((listItem) => (listItem.tables?.length || 0) > 0)),
  );

  readonly loading$: Observable<boolean> = combineLatest([
    this.integrationQuery.loading$,
    this.uiModelingQuery.loading$,
    this.sqlModelingQuery.loading$,
  ]).pipe(
    map(
      ([integrationsLoading, uiModelingLoading, sqlModelingLoading]) =>
        integrationsLoading || uiModelingLoading || sqlModelingLoading,
    ),
  );
}
